export const dateToCalendar = date => {
  if (!date) return null;
  const [day, month, year] = date.split(".");
  return `${year}-${month}-${day}`;
};
export const calendarToDate = date => {
  if (!date) return null;
  const [year, month, day] = date.split("-");
  return `${day}.${month}.${year}`;
};
